
import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

// components
import { getEmailCampaigns } from "services/emailcampaigns";
import { AppContext } from "contexts/AppContext";
import Swal from "sweetalert2";
import EmailCampaignsTable from "components/Tables/EmailCampaignsTable";

export const EmailCampaigns = () => {
  const { setEmailCampaigns, emailCampaigns } = useContext(AppContext);
  const location = useLocation();

  useEffect(() => {
    if (emailCampaigns.length === 0) {
      const fetchEmailCampaigns = async () => {
        const results = await getEmailCampaigns();
        if (results.success) {
          setEmailCampaigns(results.emailcampaigns);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: results.message,
          });
        }
      }

      fetchEmailCampaigns();
    }

    // eslint-disable-next-line
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div>
      <EmailCampaignsTable emailCampaigns={emailCampaigns} />
    </div>
  );
};

export default EmailCampaigns;
